import { BonanzaContext } from 'contexts/bonanza';
import { BonanzaStatus, getCurrentBonanzaIterationDays } from 'helpers/bonanza';
import 'moment/locale/de';
import 'moment/locale/fr';
import moment from 'moment';
import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const MIN_BONANZA_DAYS_TO_SHOW_EXTENDED = 7;

export const useBonanzaLogic = () => {
  const { bonanzaData, userBonanzaGroup } = useContext(BonanzaContext);
  const {
    i18n: { language },
  } = useTranslation();

  const isOneWeekRemains = useMemo(() => {
    if (!bonanzaData) return false;
    const now = moment();
    const diffDays = moment(bonanzaData.end).diff(now, 'days');
    return diffDays < MIN_BONANZA_DAYS_TO_SHOW_EXTENDED;
  }, [bonanzaData]);

  const iterationDays = useMemo(() => {
    if (!bonanzaData) return null;
    return getCurrentBonanzaIterationDays(
      bonanzaData.start,
      bonanzaData.end,
      language
    );
  }, [bonanzaData, language]);

  const isBonusIssued = useMemo(
    () => userBonanzaGroup === BonanzaStatus.BONUS_ISSUED,
    [userBonanzaGroup]
  );

  const isBonusLocked = useMemo(
    () => userBonanzaGroup === BonanzaStatus.PROMO_LOCKED,
    [userBonanzaGroup]
  );

  const isLockedOrIssued = useMemo(
    () => isBonusIssued || isBonusLocked,
    [isBonusIssued, isBonusLocked]
  );

  const isActiveProgress = useMemo(
    () =>
      [
        BonanzaStatus.LEVEL0,
        BonanzaStatus.LEVEL1,
        BonanzaStatus.LEVEL2,
        BonanzaStatus.LEVEL3,
        BonanzaStatus.LEVEL4,
      ].includes(userBonanzaGroup),
    [userBonanzaGroup]
  );

  return {
    isOneWeekRemains,
    isLockedOrIssued,
    isActiveProgress,
    isBonusIssued,
    isBonusLocked,
    isLastIteration: iterationDays?.isLastIteration ?? false,
    nextIterationStartDay: iterationDays?.nextStartDay ?? null,
    iterationStartDay: iterationDays?.startDay ?? null,
    iterationEndDay: iterationDays?.endDay ?? null,
    iterationEndDayFull: iterationDays?.endDayFull ?? null,
  };
};
